import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Renderer2,
    Output,
} from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { UserData } from '../auth/userData';
import { HeaderEventService } from '../header-event.service';
import { ActivatedRoute, NavigationEnd, Route, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { event } from 'jquery';
import { environment } from 'src/environments/environment';
import { Utility } from '../utility/utility';
import { PermissionEnforcer } from '../services/permission-enforcer.service';
import { ChallengeManagementService } from '../auth/Challenges/challenge-management/challenge-management.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy, OnChanges {
    role: string;
    fullname: String | any;
    isHidden: Boolean = false;
    menuSub: Subscription;
    environment = '';
    showNewBadge: boolean = false;
    term_score: any = '0';
    activeTabs = {
        course: false,
        project: false,
        'my-challenges': false,
        'attendance-tutor': false,
    };

    typeToTabName = {
        'my-projects': 'project',
        'my-challenges': 'my-challenges',
        'student-course-lesson': 'course',
        'attendance-tutor': 'attendance-tutor',
    };

    @Output('toggleSideMenuEvent') toggleSideMenuEvent = new EventEmitter<boolean>();
    @Input('sideMenuOpened') sideMenuOpened;

    uiPermissions = {
        isAdminPanel: false,
        myCourseView: false,
        myProjectsView: false,
        attendanceTutorView: false,
        myChallengesView: false,
    };

    constructor(
        private AuthService: AuthService,
        private headerService: HeaderEventService,
        private userData: UserData,
        private popover: PopoverController,
        private router: Router,
        private renderer: Renderer2,
        private utility: Utility,
        private permissionEnforcer: PermissionEnforcer,
        private challengeService: ChallengeManagementService,
    ) {
        this.markTabActive('course');
    }

    userIsAuthenticated = false;
    private authListenerSubs?: Subscription;
    isMenuOpen: boolean = false;
    termScoreLoaded: boolean = false;

    async ngOnInit() {
        // @ts-ignore
        let { location } = this.router;
        let pathName = location._platformStrategy._platformLocation.location.pathname;
        if (pathName === '/my-projects') {
            this.markTabActive('project');
        }
        if (pathName === '/my-challenges') {
            this.markTabActive('challenge');
        }
        if (environment.environmentType != 'PROD') {
            this.environment = ` ${environment.environmentType} Environment`;
        }

        //!TODO: Refactor this setInterval to a more efficient approach
        setInterval(async () => {
            this.fullname = await this.userData.getName();
            this.role = await this.userData.getRole();
            if (this.role=='student' && !this.termScoreLoaded) {
                this.loadTermScore();
            }
        }, 1000);
        this.userIsAuthenticated = await this.AuthService.getIsAuth();
        this.authListenerSubs = this.AuthService.getAuthStatusListener().subscribe(
            async (isAuthenticated) => {
                this.userIsAuthenticated = isAuthenticated;
                // if (isAuthenticated) {
                //     await this.permissionEnforcer.loadPermissions().toPromise();
                //     this.canView$ = this.permissionEnforcer.hasPermission('AdminPanel', 'view');
                //     console.log('canView$ after login:', this.canView$);
                // }
            },
        );
        this.AuthService.isBool.subscribe((response: Boolean) => {
            this.isHidden = response;
        });
        this.headerService.$menuToggle.subscribe((isMenuOpen) => {
            this.isMenuOpen = isMenuOpen;
        });
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                const activeTabName = this.typeToTabName[event.url.substring(1)];
                Object.keys(this.activeTabs).forEach((key) => {
                    this.activeTabs[key] = false;
                });
                this.activeTabs[activeTabName] = true;
            });
        this.permissionEnforcer.onPermissionsChange.subscribe(() => {
            this.setPermissions();
            if(this.uiPermissions.myChallengesView) {
                this.checkNewChallenges()
            }
        });

    }

    loadTermScore() {
        this.AuthService.getTermScoreByTermID().subscribe({
            next: (response: any) => {
                this.term_score = response?.results?.[0]?.total_pts || 0;
                setTimeout(() => {this.termScoreLoaded = true;}, 1000);
            },
            error: (error) => {
                console.error('Error fetching term score:', error);
                this.term_score = 0;
                this.termScoreLoaded = true;
            }
        });
    }

    // Generates a short display name for the user
    get shortName(): string {
        // Otherwise, take first 3 chars of first and last words
        if (!this.fullname) {
            return 'user';
        }

        // Split fullname by spaces or hyphen and derive short identifier
        const parts = this.fullname.split(/\s|-/);

        // If single word, limit to 6 chars for compact display
        if (parts.length === 1) {
            return parts[0].substring(0, 6);
        }

        // Otherwise, take first 3 chars of first and last words
        const first = parts[0].substring(0, 3);
        const last = parts[parts.length - 1].substring(0, 3);
        return `${first} ${last}`;
    }

    setPermissions() {
        const uiPermissions = {
            isAdminPanel: this.permissionEnforcer.hasPermission('AdminPanel', 'view'),
            myCourseView: this.permissionEnforcer.hasPermission('Student-Course-Lessons', 'view'),
            myProjectsView: this.permissionEnforcer.hasPermission('My-Projects', 'view'),
            attendanceTutorView: this.permissionEnforcer.hasPermission('Attendance-Tutor', 'view'),
            myChallengesView: this.permissionEnforcer.hasPermission('My-Challenges', 'view'),
        };
        this.uiPermissions = { ...this.uiPermissions, ...uiPermissions };
    }

    ngAfterViewInit() {
        const themeColor = environment ? environment.environmentTheme : '#960017';

        const backgroundColorElements = document.querySelectorAll('.backgroundColor');
        if (backgroundColorElements.length > 0) {
            backgroundColorElements.forEach((element) => {
                this.renderer.setStyle(element, 'background-color', themeColor);
            });
        } else {
            console.warn('No elements with the class "backgroundColor" found.');
        }
    }

    onLogout() {
        this.AuthService.logout();
        this.fullname = null;
        this.AuthService.isBool.next(false);
    }

    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
        // this.toggleSideMenuEvent.emit(this.isMenuOpen);
        this.headerService.toggleMenu(this.isMenuOpen);
    }

    ngOnDestroy() {
        this.authListenerSubs?.unsubscribe();
        if (this.menuSub) this.menuSub.unsubscribe();
    }

    markTabActive(tabName) {
        for (let tab in this.activeTabs) {
            this.activeTabs[tab] = false;
        }
        this.activeTabs[tabName] = true;
    }

    navigateMenu(type: string) {
        const tabName = this.typeToTabName[type];
        this.markTabActive(tabName);
        this.router.navigate([type]);
    }

    ngOnChanges(changes) {
        if (changes.sideMenuOpened) {
            this.isMenuOpen = changes.sideMenuOpened.currentValue;
        }
    }

    formatDateToUTC(date: Date): string {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    checkNewChallenges() {
        let filters = {};
        const currentDate = new Date();
        const currentDateStr = this.formatDateToUTC(currentDate);
        filters['startDate'] = currentDateStr;
        filters['endDate'] = currentDateStr;

        // Update flag if the challenges length is more than 0
        this.challengeService.getAllChallenges(undefined, undefined, filters).subscribe(
            (response) => {
                const challenges = response?.results || [];
                if (challenges.length > 0) {
                    this.showNewBadge = true;
                } else {
                    this.showNewBadge = false;
                }
            },
            (error) => {
                console.error('Error fetching new challenges:', error);
                this.showNewBadge = false;
            },
        );
    }
}
